import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  select: { paddingBottom: 0 },
}))
